import "./styles.scss";
import {MdLocationPin,} from "react-icons/md";
import {AiOutlineMail} from "react-icons/ai";
import {BsFillDoorOpenFill} from "react-icons/bs";



const Home = ({setSection}) => {

    return (
        <div className="Home">
            <div className="Home__about-me" id={"about"}>
                <h2>Information</h2>
                
                    <div
  style={{
    marginTop: "20px",
    textAlign: "center",
    width: "100vw",
    marginLeft: "calc(50% - 50vw)",
    color: "red",
  }}
>
  <p>
    You can find my new homepage <b>
      <a
        href="https://pinto-pedro.github.io/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "red" }}
      >
        HERE
      </a>
    </b>.
  </p>
</div>
            </div>
            
        </div>
    )
}

export default Home;